export function buildStudentTuitionApiFields(
  noCharge: boolean | undefined,
  tuition: number | undefined,
): {
  noCharge: boolean;
  tuition: number | null;
  isTuitionOverridden: boolean;
} {
  const resolvedNoCharge = noCharge ?? false;

  if (resolvedNoCharge) {
    return {
      noCharge: true,
      tuition: null,
      isTuitionOverridden: false,
    };
  }

  const hasCustomTuition =
    tuition !== undefined && tuition !== null && !Number.isNaN(tuition);

  return {
    noCharge: false,
    tuition: hasCustomTuition ? tuition : null,
    isTuitionOverridden: hasCustomTuition,
  };
}
